// Servicio para manejo de cookies
// Permite obtener, establecer y eliminar cookies de forma centralizada

class CookieService {
  
  // Obtener el valor de una cookie por su nombre
  getCookie(name) {
    try {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      
      if (parts.length === 2) {
        const cookieValue = parts.pop().split(';').shift();
        
        
        return cookieValue;
      }
      
      return null;
    } catch (error) {
      console.error(`%c❌ ERROR GETTING COOKIE: ${name}`, 'color: #ef4444;', error);
      return null;
    }
  }

  // Obtener y parsear una cookie JSON
  getJsonCookie(name) {
    try {
      const cookieValue = this.getCookie(name);
      
      if (!cookieValue) {
        return null;
      }

      const parsedValue = JSON.parse(decodeURIComponent(cookieValue));
      
      
      return parsedValue;
    } catch (error) {
      console.error(`%c❌ ERROR PARSING JSON COOKIE: ${name}`, 'color: #ef4444;', error);
      return null;
    }
  }

  // Establecer una cookie
  setCookie(name, value, days = 7, options = {}) {
    try {
      const expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      
      const defaultOptions = {
        expires: expires.toUTCString(),
        path: '/',
        SameSite: 'Strict',
        ...options
      };

      let cookieString = `${name}=${value}`;
      
      Object.entries(defaultOptions).forEach(([key, val]) => {
        if (val !== null && val !== undefined) {
          cookieString += `;${key}=${val}`;
        }
      });

      document.cookie = cookieString;
      
      
      return true;
    } catch (error) {
      console.error(`%c❌ ERROR SETTING COOKIE: ${name}`, 'color: #ef4444;', error);
      return false;
    }
  }

  // Establecer una cookie JSON
  setJsonCookie(name, jsonObject, days = 7, options = {}) {
    try {
      const jsonString = encodeURIComponent(JSON.stringify(jsonObject));
      return this.setCookie(name, jsonString, days, options);
    } catch (error) {
      console.error(`%c❌ ERROR SETTING JSON COOKIE: ${name}`, 'color: #ef4444;', error);
      return false;
    }
  }

  // Eliminar una cookie
  deleteCookie(name, path = '/') {
    try {
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=${path};`;
      
      
      return true;
    } catch (error) {
      console.error(`%c❌ ERROR DELETING COOKIE: ${name}`, 'color: #ef4444;', error);
      return false;
    }
  }

  // Obtener todas las cookies como objeto
  getAllCookies() {
    try {
      const cookies = {};
      const cookieArray = document.cookie.split(';');
      
      cookieArray.forEach(cookie => {
        const [name, value] = cookie.trim().split('=');
        if (name && value) {
          cookies[name] = value;
        }
      });

      
      return cookies;
    } catch (error) {
      console.error(`%c❌ ERROR GETTING ALL COOKIES`, 'color: #ef4444;', error);
      return {};
    }
  }

  // Verificar si una cookie existe
  cookieExists(name) {
    const exists = this.getCookie(name) !== null;
    
    
    return exists;
  }

  // Limpiar todas las cookies (usar con cuidado)
  clearAllCookies() {
    try {
      const cookies = this.getAllCookies();
      let deletedCount = 0;
      
      Object.keys(cookies).forEach(cookieName => {
        this.deleteCookie(cookieName);
        deletedCount++;
      });

      
      return deletedCount;
    } catch (error) {
      console.error(`%c❌ ERROR CLEARING ALL COOKIES`, 'color: #ef4444;', error);
      return 0;
    }
  }

  // Métodos de conveniencia para las cookies específicas de la aplicación
  
  // Obtener token de autenticación
  getAuthToken() {
    return this.getCookie('auth_token');
  }

  // Obtener datos del usuario
  getUserData() {
    return this.getJsonCookie('user_data');
  }

  // Obtener un campo específico de los datos del usuario
  getUserField(fieldName) {
    try {
      const userData = this.getUserData();
      if (!userData) {
        return null;
      }

      const fieldValue = userData[fieldName];
      
      
      return fieldValue || null;
    } catch (error) {
      console.error(`%c❌ ERROR GETTING USER FIELD: ${fieldName}`, 'color: #ef4444;', error);
      return null;
    }
  }

  // Verificar si el usuario está autenticado
  isAuthenticated() {
    const hasToken = this.cookieExists('auth_token');
    const hasUserData = this.cookieExists('user_data');
    const isAuth = hasToken && hasUserData;
    
    
    return isAuth;
  }

  // Verificar si el usuario puede crear asistentes
  canCreateAssistant() {
    const canCreate = this.getUserField('pertmiteCrearAsistente') === true;
    
    
    return canCreate;
  }

  // Limpiar cookies de autenticación
  clearAuthCookies() {
    
    const tokenDeleted = this.deleteCookie('auth_token');
    const userDataDeleted = this.deleteCookie('user_data');
    
    
    return tokenDeleted && userDataDeleted;
  }
}

// Crear instancia singleton
const cookieService = new CookieService();

export default cookieService;
